const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissionLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 190.21 221.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d5b4f857-18a1-4698-8afc-10046d759a79",
    transform: "translate(-920.44 -1203.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "30f77b55-10c2-4262-a3de-da0e8d23dc96",
    "data-name": "<Clipping Path>",
    d: "M1013.79,1417.36l-1.7,0a67.6,67.6,0,0,1-58.4-98.54,74.38,74.38,0,0,0,7.21-48.38h105.76a73.49,73.49,0,0,0,7.1,48.16,67.6,67.6,0,0,1-60,98.78h0Z",
    style: {
      fill: "#ffc400"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "23a03674-6d82-4ffc-8e6e-b65fd8780aa4",
    transform: "translate(-920.44 -1203.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "5e1701c9-f3ec-4826-a548-29e628945f28",
    "data-name": "<Clipping Path>",
    d: "M1069.6,1334.24h-55.81a3.94,3.94,0,1,1,0-7.89h55.81A3.94,3.94,0,1,1,1069.6,1334.24Z",
    style: {
      fill: "#0065ff"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "nopermission") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "79b3747c-2849-4bcc-9ae6-62fb118bdd7a",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,6h0a30.62,30.62,0,0,1,30.62,30.62v76.91a0,0,0,0,1,0,0H55.42a0,0,0,0,1,0,0V36.62A30.62,30.62,0,0,1,86,6Z",
    style: {
      fill: "none",
      stroke: "#0065ff",
      strokeMiterlimit: 10,
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.24,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H939.51a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1057.24,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.34,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H939.61a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1057.34,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.43,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H939.71a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1057.43,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.53,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H939.81a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1057.53,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.63,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H939.91a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1057.63,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.73,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H940a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1057.73,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.83,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H940.1a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1057.83,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.93,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H940.2a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1057.93,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H940.3a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1058,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.13,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H940.4a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1058.13,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.23,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H940.5a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1058.23,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.33,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H940.6a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1058.33,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.43,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H940.7a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1058.43,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.53,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H940.8a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1058.53,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.63,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H940.9a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1058.63,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.73,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H941a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1058.73,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.82,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H941.1a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1058.82,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.92,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H941.2a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1058.92,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H941.29a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1059,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.12,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H941.39a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1059.12,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.22,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H941.49a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1059.22,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.32,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H941.59a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1059.32,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.42,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H941.69a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1059.42,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.52,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H941.79a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1059.52,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.62,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H941.89a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1059.62,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.72,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H942a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1059.72,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.82,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H942.09a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1059.82,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.92,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H942.19a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1059.92,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H942.29a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1060,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.11,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H942.39a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1060.11,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.21,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H942.49a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1060.21,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.31,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H942.59a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1060.31,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.41,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H942.68a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1060.41,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.51,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H942.78a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1060.51,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.61,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H942.88a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1060.61,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.71,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H943a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1060.71,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.81,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H943.08a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1060.81,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.91,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H943.18a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1060.91,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H943.28a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1061,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.11,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H943.38a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1061.11,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.21,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H943.48a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1061.21,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.31,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H943.58a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1061.31,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.41,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H943.68a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1061.41,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.5,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H943.78a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1061.5,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.6,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H943.88a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1061.6,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.7,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H944a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1061.7,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.8,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H944.07a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1061.8,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.9,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H944.17a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1061.9,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H944.27a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1062,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.1,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H944.37a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1062.1,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.2,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H944.47a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1062.2,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.3,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H944.57a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1062.3,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.4,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H944.67a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1062.4,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.5,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H944.77a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1062.5,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.6,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H944.87a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1062.6,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.7,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H945a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1062.7,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.79,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H945.07a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1062.79,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.89,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H945.17a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1062.89,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H945.27a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1063,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.09,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H945.36a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1063.09,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.19,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H945.46a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1063.19,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.29,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H945.56a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1063.29,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.39,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H945.66a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1063.39,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.49,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H945.76a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1063.49,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.59,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H945.86a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1063.59,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.69,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H946a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1063.69,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.79,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H946.06a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1063.79,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.89,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H946.16a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1063.89,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H946.26a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1064,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.09,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H946.36a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1064.09,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.18,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H946.46a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1064.18,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.28,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H946.56a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1064.28,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.38,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H946.65a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1064.38,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.48,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H946.75a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1064.48,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.58,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H946.85a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1064.58,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.68,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1064.68,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.78,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947.05a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1064.78,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.88,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947.15a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1064.88,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947.25a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1065,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.08,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947.35a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1065.08,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.18,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947.45a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1065.18,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.28,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947.55a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1065.28,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.38,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947.65a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1065.38,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.47,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947.75a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1065.47,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.57,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947.85a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1065.57,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.67,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H947.95a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1065.67,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.77,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H948a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1065.77,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.87,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H948.14a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1065.87,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H948.24a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1066,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.07,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H948.34a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1066.07,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.17,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H948.44a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1066.17,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.27,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H948.54a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1066.27,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.37,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H948.64a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1066.37,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.47,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H948.74a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1066.47,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.57,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H948.84a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1066.57,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.67,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H948.94a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1066.67,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.77,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H949a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1066.77,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.86,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H949.14a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1066.86,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H949.24a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1067,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.06,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H949.33a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1067.06,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.16,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H949.43a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1067.16,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.26,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H949.53a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1067.26,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.36,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H949.63a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1067.36,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.46,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H949.73a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1067.46,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.56,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H949.83a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1067.56,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.66,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H949.93a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1067.66,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.76,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H950a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1067.76,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.86,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H950.13a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1067.86,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H950.23a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.06,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H950.33a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068.06,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.15,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H950.43a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068.15,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.25,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H950.53a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068.25,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.35,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H950.63a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068.35,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.45,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H950.72a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068.45,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.55,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H950.82a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068.55,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.65,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H950.92a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068.65,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.75,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H951a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068.75,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.85,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H951.12a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068.85,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.95,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H951.22a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1068.95,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H951.32a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1069,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.15,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H951.42a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1069.15,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.25,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H951.52a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1069.25,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.35,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H951.62a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1069.35,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.45,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H951.72a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1069.45,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.54,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H951.82a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1069.54,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.64,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H951.92a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1069.64,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.74,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H952a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1069.74,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.84,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H952.11a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1069.84,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.94,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H952.21a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1069.94,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H952.31a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1070,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.14,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H952.41a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1070.14,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.24,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H952.51a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1070.24,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.34,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H952.61a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1070.34,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.44,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H952.71a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1070.44,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.54,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H952.81a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1070.54,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.64,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H952.91a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1070.64,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.74,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H953a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1070.74,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.83,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H953.11a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1070.83,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.93,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H953.21a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1070.93,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H953.31a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1071,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.13,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H953.4a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1071.13,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.23,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H953.5a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1071.23,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.33,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H953.6a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1071.33,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.43,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H953.7a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1071.43,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.53,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H953.8a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1071.53,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.63,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H953.9a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1071.63,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.73,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H954a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1071.73,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.83,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H954.1a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1071.83,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.93,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H954.2a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1071.93,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H954.3a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1072,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.13,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H954.4a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1072.13,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.22,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H954.5a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1072.22,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.32,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H954.6a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1072.32,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.42,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H954.69a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1072.42,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.52,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H954.79a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1072.52,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.62,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H954.89a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1072.62,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.72,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H955a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1072.72,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.82,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H955.09a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1072.82,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.92,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H955.19a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1072.92,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H955.29a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1073,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.12,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H955.39a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1073.12,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.22,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H955.49a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1073.22,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.32,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H955.59a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1073.32,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.42,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H955.69a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1073.42,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.51,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H955.79a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1073.51,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.61,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H955.89a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1073.61,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.71,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H956a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1073.71,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.81,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H956.08a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1073.81,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.91,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H956.18a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1073.91,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H956.28a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1074,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.11,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H956.38a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1074.11,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.21,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H956.48a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1074.21,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.31,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H956.58a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1074.31,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.41,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H956.68a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1074.41,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.51,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H956.78a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1074.51,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.61,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H956.88a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1074.61,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.71,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H957a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1074.71,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.81,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H957.08a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1074.81,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.9,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H957.18a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1074.9,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H957.28a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1075,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.1,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H957.37a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1075.1,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.1,1268.81h0a5.05,5.05,0,0,0-4.9-6.27H957.37a5.05,5.05,0,0,0-4.9,6.27h0a66.15,66.15,0,0,1-5.78,46.37,75.49,75.49,0,1,0,134.07-.25A65.5,65.5,0,0,1,1075.1,1268.81Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "0d279255-4177-4a65-8e6f-3c28bd85078c",
    "data-name": "<Clipping Path>",
    d: "M1013.79,1417.36l-1.7,0a67.6,67.6,0,0,1-58.4-98.54,74.38,74.38,0,0,0,7.21-48.38h105.76a73.49,73.49,0,0,0,7.1,48.16,67.6,67.6,0,0,1-60,98.78h0Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ffc400"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d5b4f857-18a1-4698-8afc-10046d759a79)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 990.18,
    y: 1357.06,
    width: 106.4,
    height: 5.65,
    transform: "translate(220.9 -1555.11) rotate(40.77)",
    style: {
      fill: "#ffe380",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1010.87,1373.95a14.25,14.25,0,0,1-14.08-16.44l1.95-12.51a21.09,21.09,0,0,1,14.05-35.86l1,0a21.09,21.09,0,0,1,15,35.88l1.95,12.51a14.25,14.25,0,0,1-14.08,16.44h-5.84Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027,1330.22a13.16,13.16,0,0,1-4.22,9.67,6.31,6.31,0,0,0-1.85,5.6l2.06,13.24a6.36,6.36,0,0,1-6.28,7.34h-5.84a6.36,6.36,0,0,1-6.28-7.34l2.09-13.39a6.32,6.32,0,0,0-2-5.54,13.16,13.16,0,0,1-4.1-10.27A13.22,13.22,0,0,1,1027,1330.22Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#253858"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bca331f1-3de2-40c3-ae2f-2eeea4e5fc2f",
    "data-name": "<Clipping Path>",
    d: "M1069.6,1334.24h-55.81a3.94,3.94,0,1,1,0-7.89h55.81A3.94,3.94,0,1,1,1069.6,1334.24Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#0065ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#23a03674-6d82-4ffc-8e6e-b65fd8780aa4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1088.6,1334.24h-55.81a3.94,3.94,0,1,1,0-7.89h55.81A3.94,3.94,0,1,1,1088.6,1334.24Z",
    transform: "translate(-920.44 -1203.76)",
    style: {
      fill: "#2684ff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 167.71,
    cy: 126.54,
    r: 18.55,
    style: {
      fill: "none",
      stroke: "#2684ff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "7.88820181831494px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.65,
    y1: 163.89,
    x2: 67.79,
    y2: 163.89,
    style: {
      fill: "none",
      stroke: "#fffae5",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.76,
    y1: 181.06,
    x2: 71.23,
    y2: 172.59,
    style: {
      fill: "none",
      stroke: "#fffae5",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.93,
    y1: 188.18,
    x2: 79.93,
    y2: 175.21,
    style: {
      fill: "none",
      stroke: "#fffae5",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.8,
    y1: 109.94,
    x2: 116.66,
    y2: 109.94,
    style: {
      fill: "none",
      stroke: "#fffae5",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.69,
    y1: 92.77,
    x2: 113.22,
    y2: 101.24,
    style: {
      fill: "none",
      stroke: "#fffae5",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.52,
    y1: 85.66,
    x2: 104.52,
    y2: 98.62,
    style: {
      fill: "none",
      stroke: "#fffae5",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionLock);
export default __webpack_public_path__ + "static/media/permission-lock.aad9c2ef1826eef82a3fdc5ce69c6478.svg";
export { ForwardRef as ReactComponent };